// extracted by mini-css-extract-plugin
export default {"box":"FormBox_box__prJ8l","title":"FormBox_title__JwuZZ"};